import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.LoginComponent)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.DashboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'sure-bets',
    loadComponent: () => import('./pages/sure-bets/sure-bets').then(m => m.SureBetsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'middle-bets',
    loadComponent: () => import('./pages/middle-bets/middle-bets').then(m => m.MiddleBetsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'events',
    loadComponent: () => import('./pages/events/events').then(m => m.EventsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'grabbers',
    loadComponent: () => import('./pages/grabbers/grabbers').then(m => m.GrabbersComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'grabbers/api-football',
    loadComponent: () => import('./pages/api-football-config/api-football-config').then(m => m.ApiFootballConfigComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'sistemi',
    loadComponent: () => import('./pages/sistemi/sistemi').then(m => m.SistemiComponent),
    canActivate: [authGuard]
  },
  {
    path: 'schedine',
    loadComponent: () => import('./pages/schedine/schedine').then(m => m.SchedineComponent),
    canActivate: [authGuard]
  },
  {
    path: 'feed',
    loadComponent: () => import('./pages/feed/feed').then(m => m.FeedComponent),
    canActivate: [authGuard]
  },
  {
    path: 'leaderboard',
    loadComponent: () => import('./pages/leaderboard/leaderboard').then(m => m.LeaderboardComponent),
    canActivate: [authGuard]
  },
  {
    path: 'odd-movements',
    loadComponent: () => import('./pages/odd-movements/odd-movements').then(m => m.OddMovementsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'odd-movements/event/:eventId',
    loadComponent: () => import('./pages/odd-movement-detail/odd-movement-detail').then(m => m.OddMovementDetailComponent),
    canActivate: [authGuard]
  },
  {
    path: 'admin/users',
    loadComponent: () => import('./pages/admin-users/admin-users').then(m => m.AdminUsersComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'bookmakers',
    loadComponent: () => import('./pages/bookmaker-registry/bookmaker-registry').then(m => m.BookmakerRegistryComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'admin/events-review',
    loadComponent: () => import('./pages/events-review/events-review').then(m => m.EventsReviewComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'admin/scheduling',
    loadComponent: () => import('./pages/scheduling-config/scheduling-config').then(m => m.SchedulingConfigComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'admin/error-correction-suggestions',
    loadComponent: () => import('./pages/error-correction-suggestions/error-correction-suggestions').then(m => m.ErrorCorrectionSuggestionsComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    // Deve precedere 'profile/:nickname': altrimenti il router matcherebbe 'settings' come nickname.
    path: 'profile/settings',
    loadComponent: () => import('./pages/profile-settings/profile-settings').then(m => m.ProfileSettingsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'profile/:nickname',
    loadComponent: () => import('./pages/profile/profile').then(m => m.ProfileComponent),
    canActivate: [authGuard]
  },
];
